import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'logTable',
    label: 'Log Table',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
